import React, { Component } from "react";
import "../css/buyOptions.css";
import Dropdown from "react-dropdown";
import Checkbox from "rc-checkbox";
import "../css/checkbox.css";

import ReactGA from 'react-ga';

class BuyOptions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dropDownItems: [],
            foundations: [],
            extras: [],
            checkboxes: [],
            planPackage: "",
            planPackageId: "",
            foundation: "",
            foundationStyle: "normal",
            planStyle: "normal",
            showCallText: false
        }
    }

    render() {



        return (
            <div>
                <div className="purchaseHeader">Purchase {this.props.planId}</div>
                {this.renderCallText()}
                {this.renderPlanPackages()}
                {this.renderFoundations()}
                <div className="checkBoxes">
                    {this.state.checkboxes}
                </div>
                {this.renderAddToCartButton()}
            </div>
        );
    }


    renderAddToCartButton = () => {
        if (this.state.showCallText == false) {
            return (<div onClick={() => { this.addToCart() }} className="buyMenuAddToCartButton">Add to Cart</div>);
        }
    }

    renderPlanPackages = () => {
        var planStyle = "dropDownMenuBuy";
        if (this.state.planStyle == "red") {
            planStyle = "dropDownMenuBuyRed";
        }
        if (this.state.showCallText == false) {
            return (<Dropdown options={this.state.dropDownItems} className={planStyle} onChange={this.onPlanPackageChange} value={this.state.planPackage} placeholder="Select Plan Package" />);
        }
    }

    renderCallText = () => {
        if (this.state.showCallText == true) {
            return (
                <div style={{ width: 100 + "%", marginTop: "10px", fontFamily: 'EB Garamond', textAlign: "center" }}>
                    For pricing and ordering of this plan please call<br />
                    <a style={{ textDecoration: "none", color: "#0098c5", fontSize: "25px" }} href="tel:2519786088" data-rel="external">251-978-6088</a>
                </div>
            );
        }
    }

    renderFoundations = () => {
        console.log(this.state.foundations)
        if (Object.keys(this.state.foundations).length) {
            var foundationStyle = "dropDownMenuBuy";
            if (this.state.foundationStyle == "red") {
                foundationStyle = "dropDownMenuBuyRed";
            }
            return (
                <Dropdown options={this.state.foundations} className={foundationStyle} onChange={this.onFoundationChange} value={this.state.foundation} placeholder="Select Foundation" />
            );
        }
    }

    addToCart = () => {

        if (this.state.planPackage == "") {
            this.setState({ planStyle: "red" });
            return;
        }

        if (Object.keys(this.state.foundations).length && this.state.foundations !== [] && this.state.foundation == "") {
            this.setState({ foundationStyle: "red" });
            return;
        }

        ReactGA.event({
            category: 'User',
            action: 'Added To Cart',
            label: this.props.planId + " - " + this.state.planPackage
        });


        var json = {
            planId: this.props.planId,
            package: this.state.planPackageId,
            foundation: this.state.foundation,
            extras: this.state.extras.join(",")
        }

        var cartContents = localStorage.getItem('cart');
        if (cartContents !== null) {
            cartContents = JSON.parse(cartContents);
            cartContents = cartContents;
            cartContents.push(json);
            console.log("cartContents", cartContents)
            localStorage.setItem('cart', JSON.stringify(cartContents));
        } else {
            json = [json];
            localStorage.setItem('cart', JSON.stringify(json));
        }
        window.location.href = "/webapp/?type=cart";
        //console.log(localStorage.getItem('cart'));
    }

    onFoundationChange = (option) => {
        console.log(option)
        this.setState({
            foundation: option.label,
            foundationStyle: "normal"
        })
    }

    onPlanPackageChange = (option) => {
        console.log(option)
        this.setState({
            planPackage: option.label,
            planPackageId: option.value,
            planStyle: "normal"
        })
    }

    getBuyOptions = () => {
        var url = "https://www.houseplanstore.com/web_api/?v=getBuyOptions&planId=" + this.props.planId;
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url, true);
        xhr.onload = function (e) {
            try {


                var json = JSON.parse(xhr.responseText);
                if (json[0] !== "none") {
                    var dropDownItemsArray = [];
                    if (json[0] !== []) {
                        for (var i = 0; i < Object.keys(json[0]).length; i++) {
                            var title = json[0][i].title;
                            var price = json[0][i].price;
                            var id = json[0][i].id;
                            var labelText = title + " $" + price;
                            dropDownItemsArray.push({ value: id, label: labelText });
                        }
                    }

                    var checkboxItemsArray = [];
                    console.log(json[1])
                    if (json[1] !== []) {
                        for (var x = 0; x < Object.keys(json[1]).length; x++) {
                            checkboxItemsArray.push(
                                <div key={x} style={{ flex: 1, marginTop: "8px" }}>
                                    <label>
                                        <Checkbox
                                            idValue={json[1][x].id}
                                            onChange={(e, checked) => {
                                                console.log(e)
                                                if (!this.state.extras.includes(e.target.idValue)) {
                                                    //value not found in array, add it
                                                    var array = [e.target.idValue]
                                                    this.setState({ extras: [...this.state.extras, ...array] });
                                                } else if (this.state.extras.includes(e.target.idValue)) {
                                                    //value already exists in array, remove it
                                                    var extrasArray = this.state.extras;
                                                    for (var y = 0; y < extrasArray.length; y++) {
                                                        if (extrasArray[y] === e.target.idValue) {
                                                            extrasArray.splice(y, 1);
                                                            y--;
                                                        }
                                                    }
                                                    this.setState({ extras: extrasArray });
                                                }
                                                setTimeout(() => {
                                                    console.log(e.target.idValue, this.state.extras);
                                                }, 500);
                                            }}
                                        />
                                        &nbsp;
                                </label>
                                    {json[1][x].title} ${json[1][x].price}
                                </div>
                            )
                        }
                    }

                    var foundationItemsArray = [];
                    console.log(json[2])
                    if (Object.keys(json[2]).length) {
                        console.log("foundations")
                        for (var z = 0; z < Object.keys(json[2]).length; z++) {
                            foundationItemsArray.push({ value: json[2][z], label: json[2][z] });
                        }
                        this.setState({ foundations: [...this.state.foundations, ...foundationItemsArray] });
                    }


                    this.setState({
                        dropDownItems: [...this.state.dropDownItems, ...dropDownItemsArray],
                        checkboxes: [...this.state.checkboxes, ...checkboxItemsArray]
                    })
                } else {
                    this.setState({ showCallText: true });
                }
            } catch (err) {
                console.log(err);
            }
        }.bind(this);
        xhr.send();
    }
    //{planId:"ALP-1A1A",package:"1",foundation:"Slab",extras:"1,2,3"}


    componentDidMount() {
        this.getBuyOptions();
        ReactGA.modalview('/webapp/buyoptions/' + this.props.planId);
    }


}

export default BuyOptions;